import React, { Component } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import TripMapDrawing from 'src/component/TripReportDetail/TripMapDrawing';
import TripMapMarkerInfo from 'src/component/TripReportDetail/TripMapMarkerInfo';
import TripMapDrawingWithRoute from 'src/component/TripReportDetail/TripMapDrawingWithRoute';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-free-solid'
import Loader from 'src/js/Loader.js';
import { msgs } from 'src/js/ErrorMessage.js';
import 'openlayers/css/ol.css';
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class TripMap extends Component {

    constructor(prop) {
        super(prop);
        this.startTime = prop.startTime;
        this.sub = prop.sub;
        this.downloadId = prop.downloadId;
        this.getTripMap = prop.getTripMap;
        this.eventDetail = prop.eventDetail;
        const mapId = 'MapCmpMain' + Math.random();
        this.mapId = mapId;

        this.cooperateMap = this.cooperateMap.bind(this);
    }

    componentDidMount() {
        if (this.downloadId == 0){
            this.map = new TripMapDrawing(this.mapId, this.sub, this.startTime, this.getTripMap);
        }
        else if (this.downloadId == 1){
            this.map = new TripMapDrawingWithRoute(this.mapId, this.sub, this.startTime, this.getTripMap);
        }
    }

    // グラフと地図を連携させる
    cooperateMap(coords) {
        // グラフから取得した緯度経度の位置にマーカーを表示させる
        this.map.setEmphasisMarker(coords);
    }

    render() {
        const {t} = this.props;
        const Error = () => (
            <div>
                {
                    !this.props.isTripList ? <Alert bsStyle="danger"><p>{t("Message." + msgs['msg_common_01'])}</p></Alert> : false
                }
            </div>
        );

        // 表示させるトリップ詳細が無い場合
        if (this.props.startTime === '' || !this.props.isTripMap) {
            return (
                <Col sm={12} md={7}>
                    <Error />
                </Col>
            );
        }

        return (
            <div>         
                <Col md={12} sm={12} xs={12}>
                    <Row>
                        <TripMapMarkerInfo />
                    </Row>
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <div className="map-col">
                                <div id={this.mapId} className="MapCmpMain"></div>
                                <div id="popup" className="ol-popup">
                                    <a href="close" id="popup-closer" className="ol-popup-closer"><FontAwesomeIcon size='1x' icon={faTimes} /></a>
                                    <div id="popup-content"></div>
                                </div>
                                {
                                    this.props.tripMapLoading ? <div className="map-loader"><Loader /></div> : false
                                }
                            </div >
                        </Col>
                    </Row>
                </Col>
            </div>
        );
    }
}

export default withTranslation()(TripMap);



// WEBPACK FOOTER //
// ./src/component/TripReportDetail/TripMap.js